import * as React from "react";
import CredentialSidebar from "./CredentialSidebar";
class CredentialHome extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  componentDidMount() {
  }
  componentWillUnmount() {
  }
  render() {
    return /* @__PURE__ */ React.createElement("div", { className: "container-fluid", style: { height: "100%" } }, /* @__PURE__ */ React.createElement("div", { className: "row flex-nowrap", style: { height: "100%" } }, /* @__PURE__ */ React.createElement(CredentialSidebar, null), /* @__PURE__ */ React.createElement("div", { className: "h-100 d-flex align-items-center" }, /* @__PURE__ */ React.createElement(
      "div",
      {
        className: "p-2 col-example",
        style: {
          textAlign: "center",
          marginLeft: "100px",
          marginRight: "100px",
          width: "60%"
        }
      },
      /* @__PURE__ */ React.createElement("i", { className: "fa-solid fa-key fa-5x" }),
      /* @__PURE__ */ React.createElement("h2", { style: { fontWeight: "bolder", fontStyle: "italic" } }, "Credentials")
    ))));
  }
}
export default CredentialHome;
